<template>
  <div class="page flex-col justify-end">
    <AppHeader />

    <!-- 1. Banner -->
    <div class="home-banner-wrapper">
      <img
        class="home-banner-img"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNG609a2ca6473f9dec922efa2ebb16f620.jpg"
        alt="Banner"
      />
    </div>

    <!-- 2. About -->
    <div class="box_1 flex-col" id="about">
      <div class="about-title-wrapper flex-col align-center justify-center">
        <span class="about-title-text">{{ isEnglish ? 'About HIRAY' : '河南汇锐' }}</span>
        <div class="about-title-line"></div>
      </div>

      <div class="box_3 flex-row justify-between">
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNGf0fd5ae3ce221f75417ec4720937ca5d.jpg"
          :alt="isEnglish ? 'HIRAY' : '河南汇锐'"
        />
        <div class="group_3 flex-col">
          <div class="about-heading-box flex-col">
            <div class="about-hiray-img-wrapper">
              <span class="about-hiray-brand">Hiray Industrial Technology</span>
            </div>
            <h2 class="company-title-zh">
              {{
                isEnglish
                  ? 'Henan Hiray Industrial Technology Co., Ltd.'
                  : '河南汇锐工业技术有限公司'
              }}
            </h2>
            <span class="company-title-en">Counter-UAS&nbsp;&amp;&nbsp;Advanced&nbsp;Thermal&nbsp;Spray&nbsp;Solutions&nbsp;Provider</span>
          </div>
          <div class="about-p-list flex-col">
            <p v-for="(p, index) in aboutParagraphs" :key="'ap_' + index" class="about-p">
              {{ p }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Us（英文 About 页展示；与中文首页同一提交接口） -->
    <div v-if="isEnglish" class="group_12 flex-col" id="contact">
      <div class="contact-title-wrapper flex-col align-center justify-center">
        <span class="about-title-text">Contact Us</span>
        <div class="about-title-line"></div>
      </div>
      <div class="contact-content-box flex-row justify-between">
        <div class="contact-info-card flex-col">
          <h3 class="contact-card-title">Contact Information</h3>
          <div class="contact-info-list flex-col">
            <div class="contact-item flex-row align-start">
              <div class="contact-icon-circle flex-col align-center justify-center">
                <img
                  class="contact-icon"
                  src="../lanhu_1shouye/assets/img/FigmaDDSSlicePNG315443cebf8e2d5fa268926db5f34297.png"
                  alt="Address"
                />
              </div>
              <div class="contact-text-group flex-col">
                <span class="contact-label">Address</span>
                <span class="contact-val"
                  >Room 029, 7F, No. 257 Boxue Road, Zhengdong New District, Zhengzhou, Henan, China</span
                >
              </div>
            </div>

            <div class="contact-item flex-row align-start">
              <div class="contact-icon-circle flex-col align-center justify-center">
                <img
                  class="contact-icon"
                  src="../lanhu_1shouye/assets/img/FigmaDDSSlicePNG0c5fa50fcd692bb0535bfcaf53e5b340.png"
                  alt="Phone"
                />
              </div>
              <div class="contact-text-group flex-col">
                <span class="contact-label">Phone</span>
                <span class="contact-val">Mr.Feng (Overseas Mgr): +86 135 9259 6878</span>
                <span class="contact-val">WhatsApp: +86 135 9259 6878</span>
                <span class="contact-val">Tel: +86 371 86058612</span>
                <span class="contact-val">Mr.Wang (South China Mgr): 134 5408 0666</span>
                <span class="contact-val">Ms.Zhang (North China Mgr): 186 3866 1817</span>
              </div>
            </div>

            <div class="contact-item flex-row align-start">
              <div class="contact-icon-circle flex-col align-center justify-center">
                <img
                  class="contact-icon"
                  src="../lanhu_1shouye/assets/img/FigmaDDSSlicePNGda171ff8e90cde63f83ac9db4d6ccb5c.png"
                  alt="Email"
                />
              </div>
              <div class="contact-text-group flex-col">
                <span class="contact-label">Email</span>
                <span class="contact-val">evanfeng2024@163.com</span>
              </div>
            </div>
          </div>
        </div>

        <div class="contact-form-card flex-col">
          <h3 class="form-card-title">Send a Message</h3>
          <form class="message-form flex-col" @submit.prevent="submitMessage">
            <div class="form-row-double flex-row justify-between">
              <div class="form-group flex-col">
                <label class="form-label">Name <span class="required-star">*</span></label>
                <input
                  type="text"
                  class="form-input"
                  v-model="messageForm.name"
                  placeholder="Enter your name"
                  required
                />
              </div>
              <div class="form-group flex-col">
                <label class="form-label">Email <span class="required-star">*</span></label>
                <input
                  type="email"
                  class="form-input"
                  v-model="messageForm.email"
                  placeholder="Enter your email"
                  required
                />
              </div>
            </div>

            <div class="form-group flex-col">
              <label class="form-label">Company</label>
              <input
                type="text"
                class="form-input"
                v-model="messageForm.company"
                placeholder="Enter your company name"
              />
            </div>

            <div class="form-group flex-col">
              <label class="form-label">Message <span class="required-star">*</span></label>
              <textarea
                class="form-textarea"
                v-model="messageForm.message"
                rows="3"
                placeholder="Enter your inquiry or requirements"
                required
              ></textarea>
            </div>

            <div class="form-group flex-col">
              <label class="form-label">Phone <span class="required-star">*</span></label>
              <input
                type="tel"
                class="form-input"
                v-model="messageForm.phone"
                placeholder="Enter your phone number"
                required
              />
            </div>

            <button type="submit" class="form-submit-btn">Submit</button>
          </form>
        </div>
      </div>
    </div>

    <AppFooter />
  </div>
</template>
<script>
import { isEnglishRoute } from '@/utils/lang';
import { emptyContactForm, submitContactMessage } from '@/utils/contactApi';

const ABOUT_ZH = [
  '河南汇锐工业技术有限公司是一家专注于高端装备研发、生产、销售及技术服务的高新技术企业。公司深耕热喷涂技术与低空安全（反无人机）两大核心领域，拥有雄厚的技术研发实力、完善的生产体系以及丰富的项目实施经验，可为客户提供专业化技术支持与定制化解决方案。',
  '在热喷涂领域，公司致力于先进表面工程技术的研发与应用，为客户提供耐磨损、耐腐蚀、耐高温、抗氧化等高性能涂层解决方案，广泛服务于能源、电力、冶金、矿山、机械制造、石油化工等行业，帮助客户有效提升关键部件使用寿命、降低维护成本并提高设备运行效率。',
  '在低空安全领域，公司依托自主研发和系统集成能力，打造覆盖探测、识别、跟踪、预警及处置的反无人机综合解决方案，为城市安全、机场、油田、化工园区、电力设施、重要活动保障及关键基础设施提供可靠的低空防护体系，助力构建安全、高效的低空管理环境。',
  '汇锐工业始终坚持“技术创新驱动发展，专业服务创造价值”的经营理念，以客户需求为导向，以持续创新为动力，不断推动先进工业技术与智能安全技术的融合发展，为全球客户提供更加高效、可靠、专业的产品与解决方案。'
];

const ABOUT_EN = [
  'Henan Hiray Industrial Technology Co., Ltd. is a high-tech enterprise focused on the R&D, manufacturing, sales, and technical services of advanced equipment. The company specializes in two core domains—thermal spray technology and low-altitude security (counter-UAS)—with strong R&D capability, a complete production system, and extensive project experience, delivering professional technical support and customized solutions to customers.',
  'In thermal spray, Hiray is dedicated to advanced surface engineering R&D and applications, providing high-performance coating solutions for wear resistance, corrosion protection, high-temperature resistance, and oxidation resistance. These solutions serve energy, power, metallurgy, mining, machinery manufacturing, petrochemical, and other industries, helping customers extend critical component life, reduce maintenance costs, and improve equipment operating efficiency.',
  'In low-altitude security, leveraging in-house R&D and system integration capabilities, Hiray delivers integrated counter-UAS solutions covering detection, identification, tracking, early warning, and response. These systems support urban security, airports, oilfields, chemical parks, power facilities, major events, and critical infrastructure, helping build a safer and more efficient low-altitude management environment.',
  'Guided by the principle of “innovation-driven growth and professional service that creates value,” Hiray remains customer-oriented and innovation-led, continuously advancing the integration of industrial and intelligent security technologies to provide more efficient, reliable, and professional products and solutions to customers worldwide.'
];

export default {
  name: 'AboutHiray',
  data() {
    return {
      messageForm: emptyContactForm()
    };
  },
  computed: {
    isEnglish() {
      return isEnglishRoute(this.$route);
    },
    aboutParagraphs() {
      return this.isEnglish ? ABOUT_EN : ABOUT_ZH;
    }
  },
  mounted() {
    this.scrollToContactHash();
  },
  watch: {
    '$route.hash'() {
      this.scrollToContactHash();
    }
  },
  methods: {
    scrollToContactHash() {
      if (this.$route.hash !== '#contact' || !this.isEnglish) return;
      this.$nextTick(() => {
        const el = document.getElementById('contact');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    async submitMessage() {
      if (!this.messageForm.name || !this.messageForm.phone || !this.messageForm.message) {
        alert('Please fill in your name, phone number, and message.');
        return;
      }
      const result = await submitContactMessage(this.messageForm);
      const fallbackOk = 'Submitted successfully!';
      const fallbackFail = 'Submission failed. Please try again later.';
      // API 可能返回中文提示，英文页统一用英文反馈
      let msg = result.message || (result.ok ? fallbackOk : fallbackFail);
      if (result.ok && (!msg || /提交|完成|成功/.test(msg))) {
        msg = fallbackOk;
      } else if (!result.ok && (!msg || /失败|空|不能/.test(msg))) {
        msg = fallbackFail;
      }
      alert(msg);
      if (result.ok) {
        this.messageForm = emptyContactForm();
      }
    }
  }
};
</script>
<style scoped>
@import "./assets/index.css";

/* ==========================================================================
   首页统一版心规范：6 大区块内容左缘对齐（1550px / 92%，与 Header 同一条竖线）
   ========================================================================== */

.page {
  width: 100% !important;
  max-width: 1920px !important;
  margin: 0 auto !important;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 通栏背景区块内的版心容器统一左缘 */
#about.box_1,
.group_4 .box_5,
.group_5 .box_6,
.group_18,
.group_12 {
  width: 1550px !important;
  max-width: 92% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  box-sizing: border-box !important;
}

/* 1. 首页 Banner 第一屏大图（通栏满宽 100%，与解决方案背景图同宽） */
.home-banner-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  box-sizing: border-box;
  overflow: hidden;
}

.home-banner-img {
  width: 100% !important;
  height: 827px !important;
  object-fit: cover;
  display: block;
  border-radius: 0 !important;
}

/* 2. 第二部分：“河南汇锐” */
#about.box_1 {
  background-color: #ffffff;
  position: relative !important;
  left: auto !important;
  top: auto !important;
  width: 1550px !important;
  max-width: 92% !important;
  margin: 0 auto 60px auto !important;
  height: auto !important;
  min-height: auto !important;
  padding: 20px 0 !important;
  box-sizing: border-box;
}

.about-title-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.about-title-text {
  font-size: 38px;
  line-height: 1;
  font-weight: 900;
  font-family: "PingFang SC-Heavy", "PingFang SC", sans-serif;
  color: #000000;
  letter-spacing: 1px;
}

.about-title-line {
  width: 64px;
  height: 3.5px;
  background-color: #1e40af;
  margin-top: 12px;
  border-radius: 1px;
}

.box_3 {
  width: 100% !important;
  max-width: 100% !important;
  margin: 40px 0 0 0 !important;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 50px;
}

.image_2 {
  width: 688px !important;
  height: 520px !important;
  margin: 0 !important;
  object-fit: cover;
  flex-shrink: 0;
  border-radius: 2px;
}

.group_3 {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  width: auto !important;
  height: auto !important;
}

.about-heading-box {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.about-hiray-img-wrapper {
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
}

.about-hiray-brand {
  display: inline-block;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.25;
  color: #1e40af;
  letter-spacing: 0.02em;
  font-family: "Segoe UI", "Helvetica Neue", Arial, "PingFang SC", sans-serif;
}

.company-title-zh {
  font-size: 32px;
  line-height: 1.25;
  font-weight: 900;
  font-family: "PingFang SC-Heavy", "PingFang SC", sans-serif;
  color: #1e40af;
  margin: 4px 0 6px 0;
}

.company-title-en {
  font-size: 14px;
  line-height: 1.3;
  font-weight: 600;
  font-family: "PingFang SC-Medium", "PingFang SC", sans-serif;
  color: #1e40af;
  margin-bottom: 8px;
}

.about-p-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.about-p {
  font-size: 14px;
  line-height: 1.85;
  color: #333333;
  font-family: "PingFang SC-Regular", "PingFang SC", sans-serif;
  margin: 0;
  text-indent: 2em;
  text-align: justify;
  letter-spacing: normal;
}

/* 3. 第三部分：解决方案 */
.group_4 {
  width: 100% !important;
  height: auto !important;
  padding: 80px 0 !important;
  margin-top: 0 !important;
  background: url(./assets/img/FigmaDDSSlicePNG221b05668e11baf4cf9aa67c003a651e.jpg) center center / cover no-repeat !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  position: relative !important;
  left: auto !important;
  top: auto !important;
}

.text_18 {
  margin: 0 auto !important;
  text-align: center !important;
  width: auto !important;
}

.box_4 {
  margin: 12px auto 0 auto !important;
}

.box_5 {
  width: 1550px !important;
  max-width: 92% !important;
  margin: 40px auto 0 auto !important;
  height: auto !important;
  padding: 60px 80px !important;
  box-sizing: border-box !important;
  position: relative !important;
  left: auto !important;
  top: auto !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
}

.text-group_2 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
}

.text_19 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  margin: 0 !important;
  text-align: left !important;
  white-space: normal !important;
}

.paragraph_2 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  margin: 20px 0 0 0 !important;
  text-align: left !important;
}

.text_20 {
  width: auto !important;
  height: auto !important;
  margin: 36px 0 0 0 !important;
  text-align: left !important;
  align-self: flex-start !important;
}

/* 4. 第四部分：热喷涂设备与案例 */
.group_5 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 50px 0 30px 0 !important;
  background: url(./assets/img/FigmaDDSSlicePNGb1441abcb7aeec47d6225dd93402bd27.jpg) center center / cover no-repeat !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  box-sizing: border-box !important;
}

.box_6 {
  width: 1550px !important;
  max-width: 92% !important;
  margin: 0 auto !important;
  height: auto !important;
  background: none !important;
  padding: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  box-sizing: border-box !important;
}

.text-wrapper_5 {
  width: 100% !important;
  margin: 0 auto !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.text_21 {
  width: auto !important;
  text-align: center !important;
  font-size: 40px !important;
  font-weight: 900 !important;
  color: #000000 !important;
  line-height: 1 !important;
}

.section_1 {
  width: 129px !important;
  height: 6px !important;
  margin: 12px auto 0 auto !important;
  display: flex !important;
  justify-content: center !important;
}

.group_6 {
  width: 129px !important;
  height: 6px !important;
  background-color: rgba(30, 64, 175, 0.4) !important;
}

.text-wrapper_6 {
  width: 100% !important;
  margin: 30px auto 0 auto !important;
  display: flex !important;
  justify-content: center !important;
}

.text_22 {
  width: auto !important;
  text-align: center !important;
  font-size: 28px !important;
  color: #1e40af !important;
  font-weight: 700 !important;
  line-height: 1 !important;
}

.section_2,
.section_3 {
  width: 100% !important;
  margin: 30px 0 0 0 !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  gap: 30px !important;
  height: auto !important;
}

.block_2,
.block_3,
.block_4,
.box_9,
.box_11,
.box_12 {
  width: calc(33.333% - 20px) !important;
  flex: 1 !important;
  height: 414px !important;
  background: #ffffff !important;
  border-radius: 9px !important;
  box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.08) !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 30px 20px 20px 20px !important;
  box-sizing: border-box !important;
}

.image_3,
.image_4,
.image_5,
.image_6,
.image_7,
.image_8 {
  max-width: 80% !important;
  height: 260px !important;
  object-fit: contain !important;
  margin: 0 auto !important;
}

.group_7,
.box_7,
.box_8,
.box_10,
.block_5,
.group_8 {
  width: 100% !important;
  margin: 0 !important;
}

.text-wrapper_7 {
  width: 100% !important;
  margin: 50px auto 0 auto !important;
  display: flex !important;
  justify-content: center !important;
}

.text_35 {
  width: auto !important;
  text-align: center !important;
  font-size: 28px !important;
  color: #1e40af !important;
  font-weight: 700 !important;
  color: #000000 !important;
}

.section_4 {
  width: 100% !important;
  margin: 30px 0 0 0 !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  gap: 30px !important;
}

.group_9,
.group_10,
.group_11 {
  width: calc(33.333% - 20px) !important;
  flex: 1 !important;
  height: 80px !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 0 28px !important;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1) !important;
  margin: 0 !important;
  box-sizing: border-box !important;
}

.text_36,
.text_37,
.text_38 {
  margin: 0 !important;
  font-size: 20px !important;
  font-weight: 900 !important;
  color: #1f2937 !important;
  font-family: "PingFang SC-Heavy", "PingFang SC", sans-serif !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
}

.image-wrapper_1,
.image-wrapper_2,
.image-wrapper_3 {
  width: 34px !important;
  height: 34px !important;
  background-color: #1e40af !important;
  border-radius: 2px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 !important;
}

.label_1,
.label_2,
.label_3 {
  width: 20px !important;
  height: 20px !important;
  margin: 0 !important;
  object-fit: contain !important;
}

.section_5 {
  width: 100% !important;
  margin: 50px auto 0 auto !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  position: relative !important;
}

.text-wrapper_8 {
  margin: 0 auto !important;
  padding: 10px 36px !important;
  height: 42px !important;
  border: 2px solid #1e40af !important;
  border-radius: 4px !important;
  background: #ffffff !important;
  cursor: pointer !important;
  display: inline-flex !important;
  justify-content: center !important;
  align-items: center !important;
  box-sizing: border-box !important;
}

.text_39 {
  margin: 0 !important;
  color: #1e40af !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  white-space: nowrap !important;
  line-height: 1 !important;
}

/* 5. 第五部分：联系我们 */
.group_12 {
  width: 1550px !important;
  max-width: 92% !important;
  height: auto !important;
  min-height: 0 !important;
  margin: 20px auto 8px auto !important;
  padding: 0 0 8px 0 !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  position: relative !important;
}

.contact-title-wrapper {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  margin-bottom: 24px !important;
}

.contact-content-box {
  width: 100% !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  gap: 40px !important;
  align-items: stretch !important;
}

/* 左侧联系方式卡片 */
.contact-info-card {
  width: 440px !important;
  background-color: #f0f5ff !important;
  border-radius: 8px !important;
  padding: 40px 32px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
}

.contact-card-title {
  font-size: 22px !important;
  font-weight: 900 !important;
  color: #111827 !important;
  margin: 0 0 32px 0 !important;
}

.contact-info-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 28px !important;
}

.contact-item {
  display: flex !important;
  flex-direction: row !important;
  align-items: flex-start !important;
  gap: 16px !important;
}

.contact-icon-circle {
  width: 44px !important;
  height: 44px !important;
  border-radius: 50% !important;
  background-color: #ffffff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.08) !important;
  flex-shrink: 0 !important;
}

.contact-icon {
  width: 22px !important;
  height: 22px !important;
  object-fit: contain !important;
}

.contact-text-group {
  display: flex !important;
  flex-direction: column !important;
  gap: 6px !important;
  flex: 1 1 auto !important;
  min-width: 0 !important;
  max-width: 100% !important;
}

.contact-label {
  font-size: 16px !important;
  font-weight: 900 !important;
  color: #1f2937 !important;
}

.contact-val {
  font-size: 14px !important;
  color: #4b5563 !important;
  line-height: 1.6 !important;
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* 右侧发送消息表单 */
.contact-form-card {
  flex: 1 !important;
  background-color: #ffffff !important;
  border-radius: 8px !important;
  padding: 40px !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid #f1f5f9 !important;
  box-sizing: border-box !important;
}

.form-card-title {
  font-size: 22px !important;
  font-weight: 900 !important;
  color: #111827 !important;
  margin: 0 0 24px 0 !important;
}

.message-form {
  display: flex !important;
  flex-direction: column !important;
  gap: 20px !important;
}

.form-row-double {
  display: flex !important;
  flex-direction: row !important;
  gap: 20px !important;
}

.form-row-double .form-group {
  flex: 1 !important;
}

.form-group {
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
}

.form-label {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #374151 !important;
}

.required-star {
  color: #ef4444 !important;
}

.form-input,
.form-textarea {
  width: 100% !important;
  padding: 12px 16px !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 6px !important;
  font-size: 14px !important;
  color: #1f2937 !important;
  background-color: #ffffff !important;
  outline: none !important;
  box-sizing: border-box !important;
  transition: all 0.2s ease !important;
  font-family: inherit !important;
}

.form-input:focus,
.form-textarea:focus {
  border-color: #1e40af !important;
  box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1) !important;
}

.form-textarea {
  resize: vertical !important;
  min-height: 90px !important;
}

.form-submit-btn {
  width: 100% !important;
  height: 48px !important;
  background-color: #1e40af !important;
  color: #ffffff !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  border: none !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  margin-top: 10px !important;
  transition: background-color 0.2s ease !important;
}

.form-submit-btn:hover {
  background-color: #1d4ed8 !important;
}

/* 6. 第六部分：新闻模块 */
.group_18 {
  width: 1550px !important;
  max-width: 92% !important;
  margin: 40px auto 30px auto !important;
  height: auto !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
}

.text_75 {
  margin: 0 auto !important;
  text-align: center !important;
}

.section_9 {
  margin: 12px auto 0 auto !important;
}

.box_21 {
  /* 覆盖其它页面同名 .box_21 的 absolute 定位，避免新闻卡片脱离标题 */
  position: relative !important;
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  height: auto !important;
  margin: 40px 0 0 0 !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  gap: 30px !important;
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.box_22 {
  flex: 1 !important;
  width: calc(33.333% - 20px) !important;
  max-width: none !important;
  height: 266px !important;
  margin: 0 !important;
  padding: 32px 28px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
  position: relative !important;
  left: auto !important;
  top: auto !important;
  background-color: #ffffff !important;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease !important;
}

.box_22:hover {
  transform: translateY(-6px) !important;
  box-shadow: 0px 10px 24px 0px rgba(0, 0, 0, 0.14) !important;
}

.text_76 {
  width: 100% !important;
  margin: 0 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.text_77 {
  width: 100% !important;
  margin: 16px 0 0 0 !important;
  flex: 1 1 auto !important;
}

.text-wrapper_18 {
  /* 与标题、摘要左对齐，贴在卡片底部，避免旧 margin 把内容拉开 */
  margin: 24px 0 0 0 !important;
  width: auto !important;
  min-width: 85px !important;
  height: 33px !important;
  padding: 0 12px !important;
  box-sizing: border-box !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: rgba(30, 64, 175, 1) !important;
  border-radius: 4px !important;
  align-self: flex-start !important;
}

.text-wrapper_18.is-muted {
  background-color: #999999 !important;
}

.text_78 {
  margin: 0 !important;
  width: auto !important;
  height: auto !important;
  line-height: 1 !important;
}

/* 底部新闻跑马灯点图指示器 */
.news-dots-wrapper {
  margin-top: 36px !important;
  margin-bottom: 20px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 14px !important;
  width: 100% !important;
  position: relative !important;
  z-index: 10 !important;
}

.news-dot-item {
  width: 12px !important;
  height: 12px !important;
  border-radius: 50% !important;
  background-color: #94a3b8 !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  display: inline-block !important;
}

.news-dot-item:hover {
  background-color: #64748b !important;
  transform: scale(1.2) !important;
}

.news-dot-item.active {
  width: 32px !important;
  border-radius: 6px !important;
  background-color: #1e40af !important;
  box-shadow: 0 2px 6px rgba(30, 64, 175, 0.3) !important;
}

/* 跑马灯淡入淡出动画 */
.news-fade-enter-active, .news-fade-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease !important;
}

.news-fade-enter {
  opacity: 0 !important;
  transform: translateY(10px) !important;
}

.news-fade-leave-to {
  opacity: 0 !important;
  transform: translateY(-10px) !important;
}
</style>